export const LoadingCardDiv = (props) => {
    return (
    <div className="flex w-full flex-col gap-4">
        <div className="flex items-center gap-4">
            <div className="skeleton h-16 w-16 shrink-0 rounded-full"></div>
            <div className="flex flex-1 flex-col gap-4">
                <div className="skeleton h-4 w-full"></div>
                <div className="skeleton h-4 w-full"></div>
            </div>
        </div>
        <div className="skeleton h-20 w-full"></div>
    </div>
    )
}